<template lang="pug">
  section#Uno
    //-
      01. Front-end Development
    SectionTitle(color="#F2E059" seo="01. I am a front end developer")
      span(slot="number") 1
      span(slot="text1") Web &amp; App
      span(slot="text2") DEVELOPMENT

    blockquote.slogan(v-in-viewport.once="true") Always on the lookout of new technologies
    blockquote(v-in-viewport.once="true") With a passion for anything between visual and technical, my mission is to code high quality <strong>responsive websites</strong> focusing on exceptional <strong>user experiences</strong>.
      |  I am interested in new trends and technologies related to <strong>JavaScript</strong> and last <strong>CSS3</strong> techniques.

    Techs

    blockquote.slogan(v-in-viewport.once="true") The most important is to know "how things work"
    blockquote(v-in-viewport.once="true") As part of my workflow,
      |  I love the <strong>open source</strong> tools. There is a huge community of developers releasing under
      |  cool licences that let people freely <strong>learn</strong>, modify or improve the <strong>code</strong>.

    //- blockquote(style="margin-bottom: 6rem" v-in-viewport.once="true") Take a look at my <a class="underline" href="https://github.com/whoisjorge?tab=repositories">git</a> repositories.
</template>


<script>
  import Techs from '@/components/Techs'

  export default {
    components: {
      Techs
    }
  }
</script>


<style lang="sass" scoped>
  #Uno

    blockquote
      color: #efefef
      text-align: left
      line-height: 1.3
      font-weight: 200
      font-size: calc(1.25rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))
      margin: calc(2.5rem + (6 - 4) * (100vw - 32rem)/ (76.8 - 32)) 0
      opacity: 0

      &.in-viewport
        animation: .550s fadeIn 1250ms both

      &.slogan
        color: #fff
        font-size: calc(1.5rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))
        font-weight: bold
        margin-top: calc(1.5rem + (6 - 4) * (100vw - 32rem)/ (76.8 - 32))
        margin-bottom: -1em
        &.in-viewport
          animation: 1.25s fadeInUp2 550ms both

      > strong
        color: #fff
        font-weight: 600
</style>



// WEBPACK FOOTER //
// src/components/sections/Section01.vue